"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const get_1 = __importDefault(require("lodash/get"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../../../redux/slices/expertsSlice");
require("./about.scss");
const editProps = [
    {
        name: "Brief Bio",
        key: "bio",
        multiline: true,
        rowsMax: 6
    }
];
const EditExpert = (props) => {
    const { expert } = props;
    const onEdit = (e, key) => {
        const val = e.target.value;
        props.editExpert({ key, val });
    };
    return expert ? (react_1.default.createElement(core_1.Paper, { className: 'paper admin-blocks about', square: true },
        react_1.default.createElement("h5", { className: 'mb-15' }, "About"),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 }, editProps.map((val, key) => {
                return (react_1.default.createElement(core_1.TextField, { className: "about-text-info", variant: "outlined", key: key, onChange: (e) => onEdit(e, val.key), margin: "dense", id: val.key, multiline: val.multiline, label: val.name, type: "text", rowsMax: val.rowsMax, defaultValue: get_1.default(expert, val.key), fullWidth: true }));
            }))))) : (react_1.default.createElement(react_1.Fragment, null));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        expert: experts.editableExpert
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EditExpert);
